<template>
  <el-skeleton style="width: 100%" animated>
    <template slot="template">
      <div class="skeleton">
        <div
          class="skeleton-tr"
          v-for="t of rowArr"
          :key="t + 'loadSkeleton-tr'"
        >
          <el-skeleton-item
            v-show="haveLeftNumber"
            variant="text"
            class="small"
            :style="{
              margin:
                columns < 10 ? '0 32px' : columns < 15 ? '0 12px' : '0 6px',
            }"
          />
          <el-skeleton-item
            variant="text"
            v-for="t of columnArr"
            :key="t + 'loadSkeleton-td'"
            :style="{ margin: columns < 10 ? '0 32px' : '0 12px' }"
          />
        </div>
      </div>
    </template>
  </el-skeleton>
</template>
  <script>
export default {
  name: "loadSkeleton",
  props: {
    rows: {
      type: Number,
      default: 10,
    },
    columns: {
      type: Number,
      default: 5,
    },
    haveLeftNumber: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    rowArr() {
      const arr = [];
      for (let i = 1; i <= this.rows; i++) {
        arr.push(i);
      }
      return arr;
    },
    columnArr() {
      const arr = [];
      for (let i = 1; i <= this.columns; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
};
</script>
  <style scoped lang="scss" >
.skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.skeleton-th .el-skeleton__h1 {
  height: 20px;
}
.skeleton-tr {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 52px;
  box-sizing: border-box;
  border-bottom: 1px solid #EBEBEB;
  .el-skeleton__text:nth-child(2) {
    margin: 0 0 !important;
  }
  .el-skeleton__text:last-child{
    margin: 0 0 !important;
  }
}
.skeleton-tr * {
  height: 18px;
}
.skeleton-th .small {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 18px;
  width: 18px;
  height: 18px;
}
.skeleton-tr .small {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 18px;
  width: 178px;
}
</style>
  